export default "assets/images/icons/marker-5b1993aa.svg";